/**
 * @module constants
 */

/**
 * @constant
 * A Default version for client configuration API
 */

export const CLIENT_CONFIGURATION_API_VERSION = 'v1.0';

/**
 * @constant
 * A name of the client for Actionable Messages
 */

export const CLIENT_NAME = 'WAC_Outlook_React';

/**
 * @constant
 * A name of default theme for the client
 */

export const CLIENT_DEFAULT_THEME = 'default';

/**
 * @constant
 * A key for storing client configuration API in localStorage
 */

export const CLIENT_CONFIGURATION_LOCAL_STORAGE_KEY = 'ActionableMessages.ClientConfiguration';

/**
 * @constant
 * Client configuration data validity in milliseconds
 */

export const CLIENT_CONFIGURATION_VALIDITY = 5 * 24 * 60 * 60 * 1000;

/**
 * @constant
 * Client configuration error retry delay in milliseconds
 */

export const CLIENT_CONFIGURATION_ERROR_RETRY_DELAY = 1 * 24 * 60 * 60 * 1000;

/**
 * @constant
 * A type name for inline adaptive card
 */

export const INLINE_ADAPTIVE_CARD_TYPE = 'InlineAdaptiveCard';

/**
 * @constant
 * Event name for logging telemetry when Http post action clicked on a show card
 */

export const ACTION_CARD_POST_ACTION_CLICKED = 'ActionCardHttpPostActionClicked';

/**
 * @constant
 * Event name for logging telemetry when http post action clicked on a card
 */

export const SINGLE_CLICK_POST_ACTION_CLICKED = 'SingleClickHttpPostActionClicked';

/**
 * @constant
 * Event name for logging telemetry when auto invoke action is fired
 */

export const AUTO_INVOKE_ACTION_CLICKED = 'AutoInvokeActionClicked';

/**
 * @constant
 * A default id for an action
 */

export const DEFAULT_ACTION_ID = '30d2f5e2-6e6f-43b0-a2bd-c9d87a5cd6fd';

/**
 * @constant
 * A default http action timeout in milliseconds
 */

export const CLIENT_DEFAULT_HTTP_ACTION_TIMEOUT = 10000;

/**
 * @constant
 * A default auto invoke action timeout in milliseconds
 */

export const CLIENT_DEFAULT_AUTO_INVOKE_ACTION_TIMEOUT = 6000;
